import React, { useEffect, useState, useMemo } from "react";
import { FormGroup, Label, ListGroup, ListGroupItem, Row, Col, Input, Table } from "reactstrap";
import PropTypes from "prop-types";

import style from "./Grid.module.scss";
import { FormField, SelectFormField, CheckFormField } from "../../../../../utils";
import { commissionForm } from ".";
import CircularProgress from "../../../../CircularProgress/CircularProgress";

function RecurringCommission({
  recurrings,
  loading,
  recurring,
  recurringErrors,
  handleChange,
  setSubassets,
  services,
}) {
  return (
    <FormGroup>
      <Label>Recurring</Label>
      <ListGroup>
        {recurrings.map((r, i) => (
          <ListGroupItem key={r.type}>
            <Row>
              <Col xs={6} md={4} lg={3}>
                {r.type}
              </Col>
              <Col xs={6} md={4} lg={3}>
                <FormField
                  disabled={loading}
                  label="Suggested"
                  value={recurring[i].volume}
                  name="volume"
                  type="number"
                  description={`Must be between ${parseFloat(r.min)}
                    ${r.minForm === commissionForm.Flat ? ` ${r.currencyISO}` : "%"} and ${parseFloat(r.max)}
                    ${r.maxForm === commissionForm.Flat ? ` ${r.currencyISO}` : "%"}.`}
                  error={recurringErrors[i]}
                  onChange={(name, value) => handleChange(name, i, "recurring", value)}
                  dataTypeDecimalName="currency"
                />
              </Col>
              <Col xs={6} md={4} lg={3}>
                <SelectFormField
                  disabled={loading}
                  label="Form"
                  value={recurring[i].form.trim()}
                  name="form"
                  selectItems={
                    Object.keys(commissionForm)
                    /*.filter((key) => (r.maxForm.trim() === key || r.minForm.trim() === key))*/
                  }
                  getSelectItemId={(key) => key}
                  getSelectItemName={(key) =>
                    `${commissionForm[key]} (${key === commissionForm.Flat ? r.currencyISO.trim() : "%"})`
                  }
                  onChange={(name, value) => handleChange(name, i, "recurring", value)}
                />
              </Col>
              <Col xs={6} md={4} lg={3}>
                <FormField
                  label="Minimum Charge"
                  disabled={loading}
                  value={recurring[i].minimum}
                  name="minimum"
                  type="number"
                  onChange={(name, value) => handleChange(name, i, "recurring", value)}
                  description={`in ${r.currencyISO.trim()}`}
                  dataTypeDecimalName="currency"
                />
              </Col>
              <Col xs={6} md={4} lg={3}>
                <CheckFormField
                  label="Exclude Cash"
                  disabled={loading}
                  value={recurring[i].excludesCash}
                  initialValue={recurring[i].excludesCash}
                  name="excludesCash"
                  onChange={(name, value) => handleChange(name, i, "recurring", value)}
                />
              </Col>
            </Row>
            {parseInt(r.groupId, 10) > 0 && (
              <RecurringAssetGroup
                loading={loading}
                setSubassets={setSubassets}
                recIndex={i}
                subasset={recurring[i].subasset}
                subassetSchema={r.subasset}
                services={services}
                assetGroupId={r.groupId}
              />
            )}
          </ListGroupItem>
        ))}
        {recurring.length === 0 && <ListGroupItem>No recurring Commissions</ListGroupItem>}
      </ListGroup>
    </FormGroup>
  );
}

RecurringCommission.propTypes = {
  recurrings: PropTypes.array.isRequired,
  recurring: PropTypes.array.isRequired,
  recurringErrors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  setSubassets: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default RecurringCommission;

function RecurringAssetGroup({
  subasset,
  subassetSchema,
  services,
  setSubassets,
  recIndex,
  assetGroupId,
  loading,
}) {
  const [assetGroup, setAssetGroup] = useState(undefined);

  useEffect(() => {
    services.getAssetGroup({ id: assetGroupId }, (res) => {
      const { assetGroup: aG } = res;
      setAssetGroup(aG);
    });
  }, [assetGroupId, services]);

  useEffect(() => {
    if (assetGroup && !assetGroup.loaded) {
      const newSubassets = (assetGroup.Values || []).map((value) => {
        let newItem;
        subasset.forEach((item) => {
          if (item.value.trim() === value.AssetGroupValue.trim()) {
            newItem = {
              ...item,
              included: true,
              blocked: false,
            };
            subassetSchema.forEach((item2) => {
              if (item2.value.trim() === value.AssetGroupValue.trim()) {
                newItem.blocked = true;
              }
            });
          }
        });
        if (!newItem) {
          newItem = {
            value: value.AssetGroupValue.trim(),
            included: false,
            blocked: false,
            excludedInMin: true,
          };
        }
        return newItem;
      });
      setAssetGroup({ ...assetGroup, loaded: true });
      setSubassets(recIndex, newSubassets);
    }
  }, [assetGroup, subasset, setSubassets, recIndex, subassetSchema]);

  const handleChange = (index, name, value) => {
    const newSubassets = [...subasset];
    newSubassets[index][name] = value;
    setSubassets(recIndex, newSubassets);
  };

  if (!assetGroup || !assetGroup.loaded) return <CircularProgress sm />;

  return (
    <div className={style.grid}>
      <h6 className="my-3">
        Exluceded groups from Asset Group:{" "}
        <span className="font-weight-bold">{assetGroup.AssetGroupName}</span>
      </h6>
      <Table responsive hover>
        <thead>
          <tr>
            <th>Name</th>
            <th>Exclude in minimum</th>
            <th>Exclude</th>
          </tr>
        </thead>
        <tbody>
          {subasset.map((subAssSchema, subAssetIndex) => (
            <tr key={subAssSchema.value}>
              <td>{subAssSchema.value}</td>
              <td>
                {subAssSchema.included ? (
                  <Input
                    type="checkbox"
                    disabled={loading}
                    style={{ marginLeft: 10 }}
                    defaultChecked={subAssSchema.excludedInMin}
                    value={subAssSchema.excludedInMin}
                    onChange={({ target }) =>
                      handleChange(
                        subAssetIndex,
                        "excludedInMin",
                        target.checked === "true" || target.checked === true
                      )
                    }
                  />
                ) : (
                  "-"
                )}
              </td>
              <td>
                <Input
                  type="checkbox"
                  disabled={subAssSchema.blocked || loading}
                  style={{ marginLeft: 10 }}
                  defaultChecked={subAssSchema.included}
                  value={subAssSchema.included}
                  onChange={({ target }) =>
                    handleChange(
                      subAssetIndex,
                      "included",
                      target.checked === "true" || target.checked === true
                    )
                  }
                />
              </td>
            </tr>
          ))}
          {subasset.length === 0 && (
            <tr>
              <td colSpan={8} style={{ textAlign: "center" }}>
                No Assets in Group
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

RecurringAssetGroup.propTypes = {
  subasset: PropTypes.array.isRequired,
  subassetSchema: PropTypes.array.isRequired,
  setSubassets: PropTypes.func.isRequired,
  recIndex: PropTypes.number.isRequired,
  services: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  assetGroupId: PropTypes.any.isRequired,
};
